module.exports = __webpack_public_path__ + "img/130.a60d3c8.jpg";